import { useState } from 'react';
import ClubRegistrationRequirmentData from './ClubRegistrationRequirementData';

const useClubRegistrationRequirmentData = () => {
  const [ clubRegRequirementState, setClubRegRequirementState ] = useState(ClubRegistrationRequirmentData.INITIAL_STATE);

  const getClubRegistrationRequirment = () => {
    return ClubRegistrationRequirmentData.getClubRegistrationRequirmentData(clubRegRequirementState, setClubRegRequirementState);
  }

  return {
    clubRegRequirementState,
    getClubRegistrationRequirment
  }
}

export default useClubRegistrationRequirmentData;